import * as React from "react";
const SocialIcon = (props) => (
  <svg
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:currentColor;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"
      }
    </style>
    <circle className="st0" cx={16} cy={7} r={3} />
    <circle className="st0" cx={7.3} cy={22} r={3} />
    <circle className="st0" cx={24.7} cy={22} r={3} />
    <path
      className="st0"
      d="M22.8,24.3C21,26,18.6,27,16,27c-2.6,0-5-1-6.8-2.7"
    />
    <path
      className="st0"
      d="M19,7.5c4.1,1.3,7,5.1,7,9.5c0,0.7-0.1,1.4-0.2,2.1"
    />
    <path 
      className="st0"
      d="M6.2,19.2C6.1,18.5,6,17.8,6,17c0-4.5,2.9-8.3,7-9.5"
    />
  </svg>
);
export default SocialIcon;
